import { Offcanvas } from "bootstrap";

export function mobileNavigation() {
    return document.getElementById("sideNavBarCanvas");
}

export function mobileNavigationLauncher() {
    return document.querySelector('[aria-controls="sideNavBarCanvas"]');
}

export function hideMobileNavigation() {
    const drawer = mobileNavigation();
    if (!drawer) return;

    // Bootstrap's queued show callback activates its focus trap. Finish it
    // before hide() deactivates the trap, including a tap during slide-in.
    if (drawer.classList.contains("showing")) {
        drawer.dispatchEvent(new Event("transitionend"));
    }
    Offcanvas.getInstance(drawer)?.hide();
}
